import { Controller } from "@hotwired/stimulus"

// Submits the controller's own form on a field's change event — e.g. a
// toggle or select that should save immediately, no explicit submit button.
//
// Guards against overlapping submits: the auto-unpublish toggle wires both
// a checkbox and a number field to `change`, and editing one right after
// the other (e.g. checking the box, then immediately retyping the day
// count) would otherwise fire two in-flight PATCHes for the same form —
// whichever response commits last wins, not whichever edit was last, which
// can silently drop the second edit. Ignoring further submits until Turbo
// reports the current one finished keeps them strictly sequential.
export default class extends Controller {
  submitting = false

  submit() {
    if (this.submitting) return
    this.submitting = true
    this.element.addEventListener("turbo:submit-end", () => { this.submitting = false }, { once: true })
    this.element.requestSubmit()
  }
}
